import React, {useContext, useEffect, useState} from 'react';
import Sources from "./Components/Sources";
import DropDown from "../Componnets/DropDown";
import {Scrollbars} from "react-custom-scrollbars";
import dataConnectorContext from '../DataConnector/context/dataConnectorContext'
import ConnectorHeader from "./Components/ConnectorHeader";
import http from "../../services/api/utilities/http";
export default function SourcePreview(props) {
    const context = useContext(dataConnectorContext)
    const [source , setSource] = useState('')
    const [table , setTable] = useState({})
    const [encoding , setEncoding] = useState('')
    const [delimiter , setDelimiter] = useState('')
    useEffect(()=>{
        getData()
    },[encoding,delimiter])
    const getData = () => {
        http.get('data_connector/data_preview/'+context.state.uid,
          {
              params: {
                  encoding,
                  delimiter
              }
          })
          .then(res => {
              let {table,suggestions} = res.data.data;
              setTable(table)
          })
          .catch(err=>{
              console.log(err.response)
          })
    }
    const getSrc = () => {
        props.source.map(value => {
            if(value.id === context.state.uid)
            {
                setSource(value)
            }
        })
    }
    const back = () => {
        context.dispatch({type:'set_page', value: 'Upload File'})
        // if(props.allowDeleteSrc)
        // {
        //     props.setAllowDeleteSrc(false)
        //     let arr = props.source , newArr = []
        //     arr.splice(arr.length - 1,1)
        //     newArr = newArr.concat(arr)
        //     props.setSource(newArr)
        //     let token = localStorage.getItem('token')
        //     http.delete('data_connector/data_verification/'+props.uid+'/',
        //         {
        //             headers:{
        //                 // 'Content-Type':'multipart/form-data',
        //                 Authorization : 'Bearer '+token
        //             }
        //         })
        //         .then(res => {
        //             console.log('deleted')
        //         })
        //         .catch(err=>{
        //             console.log(err.response)
        //         })
        // }

    }
    return (
        <div className="source-preview">
            <ConnectorHeader title="Source Preview">
                    {source && <Sources  src={source}/>}
                    <p>This is the file that you’ve selected.</p>
                    <p>If every thing feels right, just click on continue button!</p>
            </ConnectorHeader>
            <div className="d-flex justify-content-between align-items-center">
                {(props.step === 'Upload File' && source) &&
                <div className="d-flex justify-content-between">
                    <DropDown setSelect={setDelimiter} className="mr-3" items={['Delimiter',',',';',':','/','other']} detected={source.delimiter}/>
                    <DropDown setSelect={setEncoding} items={['Encoding','utf-8','ascii','iso-8859-1','ISO-8859-15','Latin-1','other']} detected={source.encoding}/>
                </div>
                }
            </div>
            <div>
                <Scrollbars
                    renderTrackHorizontal={({ style, ...props }) =>
                        <div {...props} style={{ ...style, backgroundColor: '#C2C7ED', width: "98%", borderRadius: 4, height: 1, bottom: 20, right: "1%" }}/>
                    }
                    renderThumbHorizontal={({ style, ...props }) =>
                        <div {...props} style={{ ...style, backgroundColor: '#70789E', borderRadius: 4, cursor: "pointer", height: 5, bottom: 2 }}/>
                    }
                    className="scroll --table" style={{ width: 'auto', height: 320 }}>
                    <div className="d-flex mt-24 w-100">
                        {Object.keys(table).length > 0 &&
                        Object.keys(table).map((col,key)=>(
                            <div key={key} className="column wmc flex-grow-1">
                                <header className="source-preview">
                                    <p className="dark-gary f14 fw500">{col}</p>
                                    <div className="remove d-flex align-items-center justify-content-center">
                                        <svg  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M16.1042 7.89014C16.1042 7.89014 15.6517 13.5026 15.3892 15.8668C15.2642 16.996 14.5667 17.6576 13.4242 17.6785C11.25 17.7176 9.07332 17.7201 6.89999 17.6743C5.80082 17.6518 5.11499 16.9818 4.99249 15.8726C4.72832 13.4876 4.27832 7.89014 4.27832 7.89014" stroke="#FF0053" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M17.2567 5.19975H3.125" stroke="#FF0053" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M14.5335 5.19974C13.8793 5.19974 13.316 4.73724 13.1877 4.0964L12.9852 3.08307C12.8602 2.61557 12.4368 2.29224 11.9543 2.29224H8.42682C7.94432 2.29224 7.52099 2.61557 7.39599 3.08307L7.19349 4.0964C7.06516 4.73724 6.50182 5.19974 5.84766 5.19974" stroke="#FF0053" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </div>
                                </header>
                                <main className="wmc">
                                    {Object.keys(table[col]).map((index,key)=>{return index < 6 && <p key={key}>{table[col][index]}</p>})}
                                </main>
                            </div>
                        ))
                        }
                    </div>
                </Scrollbars>

            </div>
            <div className="d-flex">
                <div className="btn btn-outline mr-3" onClick={back}>Back</div>
                {/*<div className="btn" onClick={() => props.goToNext(props.step === 'Upload File' ? props.step : 'Assemble Input Source')}>Continue and Add</div>*/}
            </div>
        </div>
    );
}
